import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function AboutSection() {
  return <section id="despre" className="py-20 lg:py-32 bg-white relative overflow-hidden" data-id="element-44">
      {/* Subtle Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-lavender/20 to-transparent pointer-events-none" data-id="element-45" />

      {/* Decorative Blobs */}
      <div className="absolute top-1/4 right-0 w-[400px] h-[400px] bg-brand-gold/15 rounded-full blur-3xl animate-float pointer-events-none" data-id="element-46" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-brand-purple/15 rounded-full blur-3xl animate-float-delayed pointer-events-none" data-id="element-47" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-48">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-49">
          {/* Image Area */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full aspect-[3/4] max-w-[400px] mx-auto lg:max-w-none order-2 lg:order-1" data-id="element-50">
            {/* Decorative Glow Behind Image */}
            <div className="absolute inset-0 bg-brand-purple/20 rounded-[32px] blur-2xl transform -translate-x-4 translate-y-4" data-id="element-51" />

            {/* WOW ELEMENTS */}
            {/* Thin gold arc/semicircle bottom-left */}
            <div className="absolute -bottom-12 -left-12 w-48 h-48 border-[1.5px] border-brand-gold/40 rounded-full border-t-transparent border-r-transparent -rotate-45 -z-10" data-id="element-52" />

            {/* Cluster of 3 small gold diamonds top-right */}
            <div className="absolute -top-6 -right-4 flex flex-col gap-2 items-end" data-id="element-53">
              <div className="w-3 h-3 bg-brand-gold/60 rotate-45" data-id="element-54" />
              <div className="w-2 h-2 bg-brand-gold/40 rotate-45 mr-4" data-id="element-55" />
              <div className="w-1.5 h-1.5 bg-brand-gold/80 rotate-45 mr-1" data-id="element-56" />
            </div>

            {/* Subtle concentric circles top-left */}
            <div className="absolute -top-16 -left-16 w-32 h-32 border border-brand-gold/20 rounded-full -z-10" data-id="element-57" />
            <div className="absolute -top-12 -left-12 w-24 h-24 border border-brand-gold/30 rounded-full -z-10" data-id="element-58" />

            {/* Soft coral-to-gold gradient orb bottom-right */}
            <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-gradient-to-tl from-brand-coral/20 to-brand-gold/20 rounded-full blur-xl -z-10" data-id="element-59" />

            {/* Main Image Container */}
            <div className="relative w-full h-full rounded-[32px] shadow-warm overflow-hidden border-4 border-white" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="w-full h-full object-cover object-top" data-id="element-61" />
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2" data-id="element-62">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-text mb-4" data-id="element-63">
              Adrian Huniade
            </h2>

            <p className="font-subtitle font-medium text-brand-gold text-lg mb-8" data-id="element-64">
              Instructor Internațional Theta Healing®{' '}
              <span className="mx-2 text-brand-gold/50" data-id="element-65">·</span> Facilitator
              Heal Your Life - Metoda Louise Hay{' '}
              <span className="mx-2 text-brand-gold/50" data-id="element-66">·</span> Consilier
              Dezvoltare Personală
            </p>

            <div className="space-y-6 text-brand-textSec leading-relaxed mb-10" data-id="element-67">
              <p data-id="element-68">
                Sunt Adrian Huniade și lucrez cu oameni care simt că viața lor
                poate fi mai bună, dar nu știu de unde să înceapă schimbarea.
                Oameni care se confruntă cu blocaje emoționale, o relație
                dificilă cu banii, stres constant sau lipsa de încredere în
                sine.
              </p>
              <p data-id="element-69">
                Prin cursurile și programele Academia de Abundență, îi ghidez
                pas cu pas să identifice credințele din subconștient care îi țin
                pe loc, să le transforme și să creeze mai multă abundență,
                armonie și liniște în viața lor.
              </p>
              <p data-id="element-70">
                Integrez tehnici din Theta Healing®, metoda Louise Hay,
                meditații practice și lucru cu subconștientul. Predau într-un
                mod simplu, clar și structurat, cu multă iubire. De peste 25 de
                ani studiez și practic terapii complementare, iar ceea ce îmi
                spun oamenii cel mai des este că simt iubirea și intră ușor
                într-o stare de meditație pe care nu o întâlnesc în altă parte.
              </p>
            </div>

            <div className="bg-brand-cream/50 rounded-2xl p-8 border border-brand-gold/10" data-id="element-71">
              <h3 className="font-heading font-bold text-xl text-brand-text mb-6" data-id="element-72">
                Misiunea mea
              </h3>
              <ul className="space-y-4" data-id="element-73">
                {['De la blocaje interioare la libertate emoțională', 'De la stres și neajuns la abundență în toate ariile vieții', 'De la confuzie și stagnare la claritate și liniște interioară'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-74">
                    <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0 mt-0.5" data-id="element-75" />
                    <span className="text-brand-text font-medium" data-id="element-76">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8" data-id="element-77">
              <a href="https://academiadeabundenta.ro/despremine" target="_top" className="inline-flex items-center gap-2 bg-transparent border-2 border-brand-gold text-brand-gold font-heading font-semibold px-7 py-3.5 rounded-xl hover:bg-brand-gold hover:text-brand-cream transition-colors duration-300" data-id="element-78">
                Află mai multe despre mine
                <span aria-hidden="true" data-id="element-79">→</span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}